import React from 'react'
import useWhatsAppJourney from 'hooks/useWhatsAppJourney'
import WhatsAppIcon from '../../../static/default-whatsapp.svg'
import './WhatsappButton.scss'

const WhatsAppButton = ({ content } = {}) => {
  const { handleClick } = useWhatsAppJourney({ content })

  return (
    <button
      className="container-whatsapp"
      aria-label="Atendimento via WhatsApp"
      onClick={() => handleClick()}
      data-unique="05c0b568-1a74-4bb4-8d32-e0308b942750"
    >
      <WhatsAppIcon
        alt="Atendimento via WhatsApp"
        className="container-whatsapp__image"
        width={68}
        height={68}
      />
    </button>
  )
}

export default WhatsAppButton
